<script setup lang="tsx">
import IconXgEmpty from "../icon/IconXgEmpty.vue";
import { mapState } from "../../context/context";

const props = withDefaults(
  defineProps<{
    title?: string;
    iconWidth?: string;
  }>(),
  {
    iconWidth: "150px"
  }
);

const mappedState = mapState(["color.tertiaryFontColor"]);
</script>

<template>
  <div
    :style="{
      width: '100%',
      minWidth: props.iconWidth,
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center'
    }"
  >
    <div
      :style="{
        width: props.iconWidth
      }"
    >
      <IconXgEmpty></IconXgEmpty>
    </div>
    <div
      v-if="props.title"
      :style="{
        color: mappedState['color.tertiaryFontColor'].value,
        fontSize: '16px',
        marginTop: '12px',
        textAlign: 'center'
      }"
    >
      {{ props.title }}
    </div>
  </div>
</template>
